import { useQuery } from "@tanstack/react-query";
import { transactionApi } from "@bw/shared/api";
import type { PlayerTransactionReceiptResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

const TRANSACTION_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isTransactionId(value: string | undefined): value is string {
  return Boolean(value && TRANSACTION_ID_PATTERN.test(value));
}

/** One exact server-scoped charge/refund; no payer UID is sent from the UI. */
export function useTransactionDetail(transactionId: string | undefined) {
  return useQuery<PlayerTransactionReceiptResponse>({
    queryKey: queryKeys.me.transaction(transactionId ?? ""),
    queryFn: () => transactionApi.getDetail(transactionId!),
    enabled: isTransactionId(transactionId),
  });
}
